var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7374 27.9023H27.5859V28.9772H28.7374V27.9023Z",
    fill: "url(#paint0_linear_3934_12785)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8865 24.6807H28.7383V25.7555H29.8865V24.6807Z",
    fill: "url(#paint1_linear_3934_12785)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 13.9512H5.75V15.026H6.89822V13.9512Z",
    fill: "#FAF1CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3306 10.7324H32.1792H31.0309H29.8827V11.8041V12.879V13.9507V15.0255V16.0972V17.1721V18.2406V19.3154V20.3903V21.462V22.5369H28.7345V23.6085V24.6802H29.8827V25.7551H28.7345V24.6802H27.5831V25.7551H26.4348V26.8268H25.2866V27.9016V28.9733H24.1352H22.987V30.0482H21.8355V31.1199H20.6873H19.5391V32.1915H20.6873H21.8355H22.987H24.1352V31.1199H25.2866H26.4348V30.0482H27.5831V28.9733V27.9016H28.7345V28.9733H29.8827V27.9016V26.8268H31.0309V25.7551H32.1792V24.6802V23.6085H33.3306V22.5369V21.462H34.482V20.3903V19.3154V18.2406V17.1721V16.0972V15.0255V13.9507V12.879V11.8041V10.7324H33.3306Z",
    fill: "url(#paint2_linear_3934_12785)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8355 31.0947V31.1202H19.5391V32.1919H24.1352V31.1202H26.4348V31.0947H21.8355Z",
    fill: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7374 7.51465H27.5859V8.58952H28.7374V7.51465Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5839 10.7331V7.51485H26.4357V6.43998H25.2875V5.36511H24.136V4.29343H22.9878V3.22175H21.8268V2.15007H19.5304V1.0752H10.3445V2.15007H8.0481V3.22175H6.89664V4.29343H5.74842V5.36511H4.60339V6.43998H3.45517V8.59291H2.30376V10.7395H1.15234V21.469H2.30376V23.6156H3.45517V25.7621H4.60339V26.8338H5.75161V27.9087H6.89984V28.9804H8.05129V30.0552H10.3477V31.1269H19.5431V30.0552H21.8396V28.974H22.991V27.9023H24.1392V26.8274H25.2907V25.7557H26.4389V24.6809H27.5871V22.5375H28.7385V10.7363L27.5839 10.7331ZM5.74842 11.8048V9.6614H6.89664V8.59291H8.0481V7.52123H9.19632V6.44636H10.3445V5.37149H19.5399V6.44636H20.6882V7.52123H21.8364V8.59291H22.9878V9.66778H24.136V11.8111H25.2875V20.3942H24.136V22.5407H22.9878V23.6124H21.8268V24.6841H20.6786V25.7589H19.5304V26.8306H10.3445V25.7589H9.19632V24.6841H8.0481V23.6124H6.89664V22.5407H5.74842V20.3942H4.60339V11.8048H5.74842Z",
    fill: "url(#paint3_linear_3934_12785)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 10.7326H6.89844V11.8042V12.8791V13.9508V15.0257V16.0973V17.1722V18.2407V19.3156H8.04989V20.3904V21.4621H9.19811V22.537H10.3463V23.6087H11.4946H12.646V24.6803H13.7974H14.9425H16.0939H17.2421H18.3935V23.6087H19.5417H20.69V22.537H21.8382V21.4621H22.9896V20.3904V19.3156H24.1378V18.2407V17.1722V16.0973V15.0257V13.9508V12.8791H22.9896V11.8042V10.7326V9.66088H21.8382V8.586H20.69V7.51432H19.5417H18.3935V6.43945H17.2421H16.0939H14.9425H13.7974H12.646H11.4946V7.51432H10.3463H9.19811V8.586H8.04989V9.66088V10.7326Z",
    fill: "url(#paint4_linear_3934_12785)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1829 7.51497V6.4401V5.36523H31.0347V6.4401H29.8865H28.7383V7.51497V8.58665V9.66152H29.8865V8.58665H31.0347H32.1829V9.66152V10.7332H33.3344V9.66152V8.58665V7.51497H32.1829Z",
    fill: "url(#paint5_linear_3934_12785)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8827 4.2931V3.22142H28.7345H27.5831V2.14974H26.4348V1.07487H25.2866H24.1352V0H22.987H21.8355H20.6873H19.5391V1.07487H20.6873H21.8355V2.14974H22.987V3.22142H24.1352V4.2931H25.2866V5.36478H26.4348H27.5831H28.7345H29.8827H31.0309V4.2931H29.8827Z",
    fill: "url(#paint6_linear_3934_12785)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1829 7.51497V6.4401V5.36523H31.0347V6.4401H29.8865H28.7383V7.51497V8.58665V9.66152H29.8865V8.58665H31.0347H32.1829V9.66152V10.7332H33.3344V9.66152V8.58665V7.51497H32.1829Z",
    fill: "url(#paint7_linear_3934_12785)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1834 7.51497V6.4401V5.36523H31.0352V6.4401V7.51497H32.1834V8.58665V9.66152V10.7332H33.3348V9.66152V8.58665V7.51497H32.1834Z",
    fill: "#1D1D1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 2.14941H26.4375V3.22428H27.5858V2.14941Z",
    fill: "#1D1D1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5859 4.29238H28.7374H29.8856V3.2207H28.7374H27.5859V4.29238Z",
    fill: "#1D1D1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2881 2.15007H26.4364V1.0752H25.2881H24.1367V2.15007H25.2881Z",
    fill: "#1D1D1B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0381 4.29297H29.8867V5.36784H31.0381V4.29297Z",
    fill: "#1D1D1B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6873 1.07487H21.8355H22.987H24.1352V0H22.987H21.8355H20.6873H19.5391V1.07487H20.6873Z",
    fill: "#1D1D1B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7374 24.6807H27.5859V25.7555H28.7374V24.6807Z",
    fill: "#1D1D1B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.335 10.7324H32.1836H33.335V11.8041V12.879V13.9507V15.0255V16.0972V17.1721V18.2406V19.3154V20.3903V21.462H34.4865V20.3903V19.3154V18.2406V17.1721V16.0972V15.0255V13.9507V12.879V11.8041V10.7324H33.335Z",
    fill: "#1D1D1B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7383 26.8281V27.903V28.9747H29.8865V27.903V26.8281H28.7383Z",
    fill: "#1D1D1B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0381 25.7559H29.8867V26.8307H31.0381V25.7559Z",
    fill: "#1D1D1B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1834 21.4629V22.5378V23.6094H31.0352V24.6811V25.756H32.1834V24.6811V23.6094H33.3348V22.5378V21.4629H32.1834Z",
    fill: "#1D1D1B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1365 31.1201H22.9883V32.1918H24.1365V31.1201Z",
    fill: "#1D1D1B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 28.974V27.9023H26.4375V28.974V30.0489H27.5858V28.974Z",
    fill: "#1D1D1B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4405 30.0488H25.2891V31.1237H26.4405V30.0488Z",
    fill: "#1D1D1B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.543 30.0488V31.1205H18.3948H17.2434H16.0952H14.9438H13.7987H12.6473H11.4959H10.3477V32.1922H11.4959H12.6473H13.7987H14.9438H16.0952H17.2434H18.3948H19.543V31.1205H20.6913H21.8395V30.0488H20.6913H19.543Z",
    fill: "#1D1D1B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 28.9746H21.8359V30.0495H22.9874V28.9746Z",
    fill: "#1D1D1B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1365 27.903H22.9883V28.9747H24.1365H25.2879V27.903V26.8281H24.1365V27.903Z",
    fill: "#1D1D1B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4405 25.7559H25.2891V26.8307H26.4405V25.7559Z",
    fill: "#1D1D1B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 24.6807H26.4375V25.7555H27.5858V24.6807Z",
    fill: "#1D1D1B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5859 23.6088V24.6805H28.7374V23.6088V22.5371H27.5859V23.6088Z",
    fill: "#1D1D1B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7383 11.8047V12.8796V13.9512V15.0261V16.0978V17.1727V18.2411V19.316V20.3909V21.4626V22.5374H29.8865V21.4626V20.3909V19.316V18.2411V17.1727V16.0978V15.0261V13.9512V12.8796V11.8047H28.7383Z",
    fill: "#1D1D1B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5859 9.66081V10.7325H28.7374V9.66081V8.58594H27.5859V9.66081Z",
    fill: "#1D1D1B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 6.43945H26.4375V7.51432H27.5858V6.43945Z",
    fill: "#1D1D1B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8357 23.6094H20.6875V24.6811H21.8357V23.6094Z",
    fill: "#1D1D1B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 11.8045V12.8794H24.1356V13.951V15.0259V16.0976V17.1725V18.241V19.3158H22.9874V20.3907V21.4624H21.8359V22.5372V23.6089H22.9874V22.5372H24.1356V21.4624V20.3907H25.287V19.3158V18.241V17.1725V16.0976V15.0259V13.951V12.8794V11.8045H24.1356V10.7328V9.66113H22.9874V10.7328V11.8045Z",
    fill: "#1D1D1B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 8.58594H21.8359V9.66081H22.9874V8.58594Z",
    fill: "#1D1D1B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8357 7.51465H20.6875V8.58952H21.8357V7.51465Z",
    fill: "#1D1D1B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4405 5.36523H25.2891V6.4401H26.4405V5.36523Z",
    fill: "#1D1D1B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2881 4.29297H24.1367V5.36784H25.2881V4.29297Z",
    fill: "#1D1D1B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1365 3.2207H22.9883V4.29238H24.1365V3.2207Z",
    fill: "#1D1D1B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 2.14941H21.8359V3.22428H22.9874V2.14941Z",
    fill: "#1D1D1B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5391 2.15007H20.6873H21.8355V1.0752H20.6873H19.5391V2.15007Z",
    fill: "#1D1D1B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.199 30.0488H8.05078V31.1205H9.199H10.3472V30.0488H9.199Z",
    fill: "#1D1D1B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 28.9746H6.89844V30.0495H8.04989V28.9746Z",
    fill: "#1D1D1B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74978 27.903V26.8281H4.60156V27.903V28.9747H5.74978H6.89801V27.903H5.74978Z",
    fill: "#1D1D1B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60135 25.7559H3.45312V26.8307H4.60135V25.7559Z",
    fill: "#1D1D1B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4957 26.8272H12.6471H13.7985H14.9436H16.095H17.2432H18.3946H19.5428V25.7555H20.6911V24.6807H19.5428H18.3946V25.7555H17.2432H16.095H14.9436H13.7985H12.6471H11.4957V24.6807H10.3474H9.19922V25.7555H10.3474V26.8272H11.4957Z",
    fill: "#1D1D1B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.199 23.6094H8.05078V24.6811H9.199V23.6094Z",
    fill: "#1D1D1B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4522 23.6094H2.30078V24.6811V25.7559H3.4522V24.6811V23.6094Z",
    fill: "#1D1D1B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29985 21.4629H1.14844V22.5378V23.6094H2.29985V22.5378V21.4629Z",
    fill: "#1D1D1B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14826 19.316V18.2411V17.1727V16.0978V15.0261V13.9512V12.8796V11.8047H0V12.8796V13.9512V15.0261V16.0978V17.1727V18.2411V19.316V20.3909H1.14826V19.316Z",
    fill: "#1D1D1B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04946 21.4621H6.89801V20.3904V19.3155H5.74978V18.2406V17.1721V16.0973V15.0256V13.9507V12.879H6.89801V11.8042V10.7325H8.04946V9.66081V8.58594H6.89801V9.66081H5.74978V10.7325V11.8042H4.60156V12.879V13.9507V15.0256V16.0973V17.1721V18.2406V19.3155V20.3904H5.74978V21.4621V22.5369H6.89801V23.6086H8.04946V22.5369V21.4621Z",
    fill: "#1D1D1B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29985 9.66081V8.58594H1.14844V9.66081V10.7325H2.29985V9.66081Z",
    fill: "#1D1D1B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.199 7.51465H8.05078V8.58952H9.199V7.51465Z",
    fill: "#1D1D1B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4522 7.51432V6.43945H2.30078V7.51432V8.586H3.4522V7.51432Z",
    fill: "#1D1D1B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4957 7.51497V6.4401H12.6471H13.7985H14.9436H16.095H17.2432H18.3946V7.51497H19.5428H20.6911V6.4401H19.5428V5.36523H18.3946H17.2432H16.095H14.9436H13.7985H12.6471H11.4957H10.3474V6.4401H9.19922V7.51497H10.3474H11.4957Z",
    fill: "#1D1D1B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60135 5.36523H3.45312V6.4401H4.60135V5.36523Z",
    fill: "#1D1D1B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75298 4.29297H4.60156V5.36784H5.75298V4.29297Z",
    fill: "#1D1D1B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 3.2207H5.75V4.29238H6.89822V3.2207Z",
    fill: "#1D1D1B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 2.14941H6.89844V3.22428H8.04989V2.14941Z",
    fill: "#1D1D1B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3472 2.15007V1.0752H9.199H8.05078V2.15007H9.199H10.3472Z",
    fill: "#1D1D1B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6473 1.07487H13.7987H14.9438H16.0952H17.2434H18.3948H19.543V0H18.3948H17.2434H16.0952H14.9438H13.7987H12.6473H11.4959H10.3477V1.07487H11.4959H12.6473Z",
    fill: "#1D1D1B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0347 8.58594H29.8865V9.66081H28.7383V10.7325V11.8042H29.8865V10.7325H31.0347H32.1829V9.66081V8.58594H31.0347Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8854 5.36523H28.7372H27.5858H26.4375V6.4401H27.5858V7.51497H28.7372V6.4401H29.8854H31.0336V5.36523H29.8854Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0948 24.6811H14.9433H13.7983H12.6469V23.6094H11.4954H10.3472V22.5378H9.199V21.4629H8.05078V22.5378V23.6094H9.199V24.6811H10.3472H11.4954V25.756H12.6469H13.7983H14.9433H16.0948H17.243H18.3944V24.6811H17.243H16.0948Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3906 23.6094V24.6811H19.5388H20.6871V23.6094H19.5388H18.3906Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8357 22.5371H20.6875V23.612H21.8357V22.5371Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 19.3164H6.89844V20.3913V21.463H8.04989V20.3913V19.3164Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 17.1719V16.0971V15.0254H5.75V16.0971V17.1719V18.2404V19.3153H6.89822V18.2404V17.1719Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 12.8789H5.75V13.9538H6.89822V12.8789Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7374 27.9023H27.5859V28.9772H28.7374V27.9023Z",
    fill: "url(#paint8_linear_3934_12785)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8865 24.6807H28.7383V25.7555H29.8865V24.6807Z",
    fill: "url(#paint9_linear_3934_12785)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 13.9512H5.75V15.026H6.89822V13.9512Z",
    fill: "#FAF1CE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3306 10.7324H32.1792H31.0309H29.8827V11.8041V12.879V13.9507V15.0255V16.0972V17.1721V18.2406V19.3154V20.3903V21.462V22.5369H28.7345V23.6085V24.6802H29.8827V25.7551H28.7345V24.6802H27.5831V25.7551H26.4348V26.8268H25.2866V27.9016V28.9733H24.1352H22.987V30.0482H21.8355V31.1199H20.6873H19.5391V32.1915H20.6873H21.8355H22.987H24.1352V31.1199H25.2866H26.4348V30.0482H27.5831V28.9733V27.9016H28.7345V28.9733H29.8827V27.9016V26.8268H31.0309V25.7551H32.1792V24.6802V23.6085H33.3306V22.5369V21.462H34.482V20.3903V19.3154V18.2406V17.1721V16.0972V15.0255V13.9507V12.879V11.8041V10.7324H33.3306Z",
    fill: "url(#paint10_linear_3934_12785)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8355 31.0947V31.1202H19.5391V32.1919H24.1352V31.1202H26.4348V31.0947H21.8355Z",
    fill: "#1D1D1B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7374 7.51465H27.5859V8.58952H28.7374V7.51465Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5839 10.7331V7.51485H26.4357V6.43998H25.2875V5.36511H24.136V4.29343H22.9878V3.22175H21.8268V2.15007H19.5304V1.0752H10.3445V2.15007H8.0481V3.22175H6.89664V4.29343H5.74842V5.36511H4.60339V6.43998H3.45517V8.59291H2.30376V10.7395H1.15234V21.469H2.30376V23.6156H3.45517V25.7621H4.60339V26.8338H5.75161V27.9087H6.89984V28.9804H8.05129V30.0552H10.3477V31.1269H19.5431V30.0552H21.8396V28.974H22.991V27.9023H24.1392V26.8274H25.2907V25.7557H26.4389V24.6809H27.5871V22.5375H28.7385V10.7363L27.5839 10.7331ZM5.74842 11.8048V9.6614H6.89664V8.59291H8.0481V7.52123H9.19632V6.44636H10.3445V5.37149H19.5399V6.44636H20.6882V7.52123H21.8364V8.59291H22.9878V9.66778H24.136V11.8111H25.2875V20.3942H24.136V22.5407H22.9878V23.6124H21.8268V24.6841H20.6786V25.7589H19.5304V26.8306H10.3445V25.7589H9.19632V24.6841H8.0481V23.6124H6.89664V22.5407H5.74842V20.3942H4.60339V11.8048H5.74842Z",
    fill: "url(#paint11_linear_3934_12785)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 10.7326H6.89844V11.8042V12.8791V13.9508V15.0257V16.0973V17.1722V18.2407V19.3156H8.04989V20.3904V21.4621H9.19811V22.537H10.3463V23.6087H11.4946H12.646V24.6803H13.7974H14.9425H16.0939H17.2421H18.3935V23.6087H19.5417H20.69V22.537H21.8382V21.4621H22.9896V20.3904V19.3156H24.1378V18.2407V17.1722V16.0973V15.0257V13.9508V12.8791H22.9896V11.8042V10.7326V9.66088H21.8382V8.586H20.69V7.51432H19.5417H18.3935V6.43945H17.2421H16.0939H14.9425H13.7974H12.646H11.4946V7.51432H10.3463H9.19811V8.586H8.04989V9.66088V10.7326Z",
    fill: "url(#paint12_linear_3934_12785)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1829 7.51497V6.4401V5.36523H31.0347V6.4401H29.8865H28.7383V7.51497V8.58665V9.66152H29.8865V8.58665H31.0347H32.1829V9.66152V10.7332H33.3344V9.66152V8.58665V7.51497H32.1829Z",
    fill: "url(#paint13_linear_3934_12785)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8827 4.2931V3.22142H28.7345H27.5831V2.14974H26.4348V1.07487H25.2866H24.1352V0H22.987H21.8355H20.6873H19.5391V1.07487H20.6873H21.8355V2.14974H22.987V3.22142H24.1352V4.2931H25.2866V5.36478H26.4348H27.5831H28.7345H29.8827H31.0309V4.2931H29.8827Z",
    fill: "url(#paint14_linear_3934_12785)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1829 7.51497V6.4401V5.36523H31.0347V6.4401H29.8865H28.7383V7.51497V8.58665V9.66152H29.8865V8.58665H31.0347H32.1829V9.66152V10.7332H33.3344V9.66152V8.58665V7.51497H32.1829Z",
    fill: "url(#paint15_linear_3934_12785)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1834 7.51497V6.4401V5.36523H31.0352V6.4401V7.51497H32.1834V8.58665V9.66152V10.7332H33.3348V9.66152V8.58665V7.51497H32.1834Z",
    fill: "#1D1D1B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 2.14941H26.4375V3.22428H27.5858V2.14941Z",
    fill: "#1D1D1B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5859 4.29238H28.7374H29.8856V3.2207H28.7374H27.5859V4.29238Z",
    fill: "#1D1D1B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2881 2.15007H26.4364V1.0752H25.2881H24.1367V2.15007H25.2881Z",
    fill: "#1D1D1B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0381 4.29297H29.8867V5.36784H31.0381V4.29297Z",
    fill: "#1D1D1B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6873 1.07487H21.8355H22.987H24.1352V0H22.987H21.8355H20.6873H19.5391V1.07487H20.6873Z",
    fill: "#1D1D1B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7374 24.6807H27.5859V25.7555H28.7374V24.6807Z",
    fill: "#1D1D1B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M33.335 10.7324H32.1836H33.335V11.8041V12.879V13.9507V15.0255V16.0972V17.1721V18.2406V19.3154V20.3903V21.462H34.4865V20.3903V19.3154V18.2406V17.1721V16.0972V15.0255V13.9507V12.879V11.8041V10.7324H33.335Z",
    fill: "#1D1D1B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7383 26.8281V27.903V28.9747H29.8865V27.903V26.8281H28.7383Z",
    fill: "#1D1D1B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0381 25.7559H29.8867V26.8307H31.0381V25.7559Z",
    fill: "#1D1D1B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1834 21.4629V22.5378V23.6094H31.0352V24.6811V25.756H32.1834V24.6811V23.6094H33.3348V22.5378V21.4629H32.1834Z",
    fill: "#1D1D1B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1365 31.1201H22.9883V32.1918H24.1365V31.1201Z",
    fill: "#1D1D1B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 28.974V27.9023H26.4375V28.974V30.0489H27.5858V28.974Z",
    fill: "#1D1D1B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4405 30.0488H25.2891V31.1237H26.4405V30.0488Z",
    fill: "#1D1D1B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.543 30.0488V31.1205H18.3948H17.2434H16.0952H14.9438H13.7987H12.6473H11.4959H10.3477V32.1922H11.4959H12.6473H13.7987H14.9438H16.0952H17.2434H18.3948H19.543V31.1205H20.6913H21.8395V30.0488H20.6913H19.543Z",
    fill: "#1D1D1B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 28.9746H21.8359V30.0495H22.9874V28.9746Z",
    fill: "#1D1D1B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1365 27.903H22.9883V28.9747H24.1365H25.2879V27.903V26.8281H24.1365V27.903Z",
    fill: "#1D1D1B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4405 25.7559H25.2891V26.8307H26.4405V25.7559Z",
    fill: "#1D1D1B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 24.6807H26.4375V25.7555H27.5858V24.6807Z",
    fill: "#1D1D1B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5859 23.6088V24.6805H28.7374V23.6088V22.5371H27.5859V23.6088Z",
    fill: "#1D1D1B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7383 11.8047V12.8796V13.9512V15.0261V16.0978V17.1727V18.2411V19.316V20.3909V21.4626V22.5374H29.8865V21.4626V20.3909V19.316V18.2411V17.1727V16.0978V15.0261V13.9512V12.8796V11.8047H28.7383Z",
    fill: "#1D1D1B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5859 9.66081V10.7325H28.7374V9.66081V8.58594H27.5859V9.66081Z",
    fill: "#1D1D1B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5858 6.43945H26.4375V7.51432H27.5858V6.43945Z",
    fill: "#1D1D1B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8357 23.6094H20.6875V24.6811H21.8357V23.6094Z",
    fill: "#1D1D1B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 11.8045V12.8794H24.1356V13.951V15.0259V16.0976V17.1725V18.241V19.3158H22.9874V20.3907V21.4624H21.8359V22.5372V23.6089H22.9874V22.5372H24.1356V21.4624V20.3907H25.287V19.3158V18.241V17.1725V16.0976V15.0259V13.951V12.8794V11.8045H24.1356V10.7328V9.66113H22.9874V10.7328V11.8045Z",
    fill: "#1D1D1B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 8.58594H21.8359V9.66081H22.9874V8.58594Z",
    fill: "#1D1D1B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8357 7.51465H20.6875V8.58952H21.8357V7.51465Z",
    fill: "#1D1D1B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4405 5.36523H25.2891V6.4401H26.4405V5.36523Z",
    fill: "#1D1D1B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2881 4.29297H24.1367V5.36784H25.2881V4.29297Z",
    fill: "#1D1D1B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1365 3.2207H22.9883V4.29238H24.1365V3.2207Z",
    fill: "#1D1D1B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9874 2.14941H21.8359V3.22428H22.9874V2.14941Z",
    fill: "#1D1D1B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5391 2.15007H20.6873H21.8355V1.0752H20.6873H19.5391V2.15007Z",
    fill: "#1D1D1B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M9.199 30.0488H8.05078V31.1205H9.199H10.3472V30.0488H9.199Z",
    fill: "#1D1D1B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 28.9746H6.89844V30.0495H8.04989V28.9746Z",
    fill: "#1D1D1B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74978 27.903V26.8281H4.60156V27.903V28.9747H5.74978H6.89801V27.903H5.74978Z",
    fill: "#1D1D1B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60135 25.7559H3.45312V26.8307H4.60135V25.7559Z",
    fill: "#1D1D1B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4957 26.8272H12.6471H13.7985H14.9436H16.095H17.2432H18.3946H19.5428V25.7555H20.6911V24.6807H19.5428H18.3946V25.7555H17.2432H16.095H14.9436H13.7985H12.6471H11.4957V24.6807H10.3474H9.19922V25.7555H10.3474V26.8272H11.4957Z",
    fill: "#1D1D1B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M9.199 23.6094H8.05078V24.6811H9.199V23.6094Z",
    fill: "#1D1D1B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4522 23.6094H2.30078V24.6811V25.7559H3.4522V24.6811V23.6094Z",
    fill: "#1D1D1B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29985 21.4629H1.14844V22.5378V23.6094H2.29985V22.5378V21.4629Z",
    fill: "#1D1D1B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14826 19.316V18.2411V17.1727V16.0978V15.0261V13.9512V12.8796V11.8047H0V12.8796V13.9512V15.0261V16.0978V17.1727V18.2411V19.316V20.3909H1.14826V19.316Z",
    fill: "#1D1D1B"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04946 21.4621H6.89801V20.3904V19.3155H5.74978V18.2406V17.1721V16.0973V15.0256V13.9507V12.879H6.89801V11.8042V10.7325H8.04946V9.66081V8.58594H6.89801V9.66081H5.74978V10.7325V11.8042H4.60156V12.879V13.9507V15.0256V16.0973V17.1721V18.2406V19.3155V20.3904H5.74978V21.4621V22.5369H6.89801V23.6086H8.04946V22.5369V21.4621Z",
    fill: "#1D1D1B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29985 9.66081V8.58594H1.14844V9.66081V10.7325H2.29985V9.66081Z",
    fill: "#1D1D1B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M9.199 7.51465H8.05078V8.58952H9.199V7.51465Z",
    fill: "#1D1D1B"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4522 7.51432V6.43945H2.30078V7.51432V8.586H3.4522V7.51432Z",
    fill: "#1D1D1B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4957 7.51497V6.4401H12.6471H13.7985H14.9436H16.095H17.2432H18.3946V7.51497H19.5428H20.6911V6.4401H19.5428V5.36523H18.3946H17.2432H16.095H14.9436H13.7985H12.6471H11.4957H10.3474V6.4401H9.19922V7.51497H10.3474H11.4957Z",
    fill: "#1D1D1B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60135 5.36523H3.45312V6.4401H4.60135V5.36523Z",
    fill: "#1D1D1B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75298 4.29297H4.60156V5.36784H5.75298V4.29297Z",
    fill: "#1D1D1B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 3.2207H5.75V4.29238H6.89822V3.2207Z",
    fill: "#1D1D1B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 2.14941H6.89844V3.22428H8.04989V2.14941Z",
    fill: "#1D1D1B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3472 2.15007V1.0752H9.199H8.05078V2.15007H9.199H10.3472Z",
    fill: "#1D1D1B"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6473 1.07487H13.7987H14.9438H16.0952H17.2434H18.3948H19.543V0H18.3948H17.2434H16.0952H14.9438H13.7987H12.6473H11.4959H10.3477V1.07487H11.4959H12.6473Z",
    fill: "#1D1D1B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0347 8.58594H29.8865V9.66081H28.7383V10.7325V11.8042H29.8865V10.7325H31.0347H32.1829V9.66081V8.58594H31.0347Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8854 5.36523H28.7372H27.5858H26.4375V6.4401H27.5858V7.51497H28.7372V6.4401H29.8854H31.0336V5.36523H29.8854Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0948 24.6811H14.9433H13.7983H12.6469V23.6094H11.4954H10.3472V22.5378H9.199V21.4629H8.05078V22.5378V23.6094H9.199V24.6811H10.3472H11.4954V25.756H12.6469H13.7983H14.9433H16.0948H17.243H18.3944V24.6811H17.243H16.0948Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3906 23.6094V24.6811H19.5388H20.6871V23.6094H19.5388H18.3906Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8357 22.5371H20.6875V23.612H21.8357V22.5371Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04989 19.3164H6.89844V20.3913V21.463H8.04989V20.3913V19.3164Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 17.1719V16.0971V15.0254H5.75V16.0971V17.1719V18.2404V19.3153H6.89822V18.2404V17.1719Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89822 12.8789H5.75V13.9538H6.89822V12.8789Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0174 20.0003V11.1157H13.5558V12.3849H14.825V13.6541H16.0943V12.3849H17.3635V11.1157H19.902V20.0003H17.3635V14.9234H16.0943V17.4618H14.825V14.9234H13.5558V20.0003H11.0174Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3934_12785",
    x1: 28.1616,
    y1: 27.8879,
    x2: 28.1616,
    y2: 28.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3934_12785",
    x1: 29.3124,
    y1: 24.6662,
    x2: 29.3124,
    y2: 25.7555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3934_12785",
    x1: 27.0105,
    y1: 10.444,
    x2: 27.0105,
    y2: 32.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3934_12785",
    x1: 14.9454,
    y1: 0.671299,
    x2: 14.9454,
    y2: 31.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3934_12785",
    x1: 15.5181,
    y1: 6.19429,
    x2: 15.5181,
    y2: 24.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3934_12785",
    x1: 31.0363,
    y1: 5.29309,
    x2: 31.0363,
    y2: 10.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3934_12785",
    x1: 25.285,
    y1: -0.072103,
    x2: 25.285,
    y2: 5.36478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3934_12785",
    x1: 31.0363,
    y1: 5.29309,
    x2: 31.0363,
    y2: 10.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3934_12785",
    x1: 28.1616,
    y1: 27.8879,
    x2: 28.1616,
    y2: 28.9772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3934_12785",
    x1: 29.3124,
    y1: 24.6662,
    x2: 29.3124,
    y2: 25.7555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3934_12785",
    x1: 27.0105,
    y1: 10.444,
    x2: 27.0105,
    y2: 32.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3934_12785",
    x1: 14.9454,
    y1: 0.671299,
    x2: 14.9454,
    y2: 31.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3934_12785",
    x1: 15.5181,
    y1: 6.19429,
    x2: 15.5181,
    y2: 24.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3934_12785",
    x1: 31.0363,
    y1: 5.29309,
    x2: 31.0363,
    y2: 10.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3934_12785",
    x1: 25.285,
    y1: -0.072103,
    x2: 25.285,
    y2: 5.36478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3934_12785",
    x1: 31.0363,
    y1: 5.29309,
    x2: 31.0363,
    y2: 10.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FAE61C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4CF038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#33C6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7475FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D457FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemeLogo);
export default __webpack_public_path__ + "static/media/meme-logo.6aa89b3a86ae853d405e2ef4ab9d56b3.svg";
export { ForwardRef as ReactComponent };